module.exports = __webpack_public_path__ + "img/logo.eba05796.png";